import { inject } from '@angular/core';
import { type CanActivateFn, type GuardResult, type MaybeAsync } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

export const AuthGuard: CanActivateFn = (_, state): MaybeAsync<GuardResult> => {
  const authService = inject(AuthService);

  if (!authService.isAuthenticated()) {
    authService.logout(true, state.url);
    return false;
  }

  return true;
};
